import { Injectable } from '@angular/core';

@Injectable()
export class MSDocService {
    constructor() {
    }
    public dev() {
    }
}